import { DataItemType, FormControlType } from "../../../schema";
import schema from "./schema";
import conduct from "./conduct";
import design from "./components/design.vue";
import pc from "./components/pc-upload.vue";
import mobile from "./components/mobile-upload.vue";
export const info = {
    title: "附件",
    title_i18n: "{\"zh\": \"附件\", \"en\": \"Attachment\"}",
    type: "attachment",
    icon: "h-icon-all-user-o",
    dataItemType: DataItemType.Attachment,
    formControllerType: FormControlType.Attachment,
    group: "基础控件",
};
export default {
    info,
    schema,
    conduct,
    components: {
        design,
        pc,
        mobile
    },
};
